import React from 'react';
import { YunxinBottom, Button, Icon } from '@/components';
import { useLocation, useIntl } from 'umi';
import { TIPS_TYPE } from '@/types/tips';
import classnames from 'classnames';
import { checkBrowerAble } from '@/utils/deviceCheck';
import copyToClipboard from 'copy-to-clipboard';
import { message } from 'antd';
import Style from './index.less';

interface TipsProps {}

const Tips: React.FC<TipsProps> = props => {
  const { formatMessage } = useIntl();
  const location: any = useLocation();
  const { query } = location;
  let text = '感谢使用网页版 POPO 会议';
  let url = '';
  let browerDiable = false;
  if (query.type) {
    if (query.type === TIPS_TYPE.FINISHED) {
      text = formatMessage({ id: 'MEETING_EXPIRED' });
    }
    if (query.type === TIPS_TYPE.DISABLE_TOKEN) {
      text = formatMessage({ id: 'DISABLE_TOKEN' });
    }
    if (query.type === TIPS_TYPE.NOT_FOUND) {
      text = formatMessage({ id: 'MEETING_NOT_EXIST' });
    }
    if (query.type === TIPS_TYPE.IOS_UNDER_13) {
      text = formatMessage({ id: 'IOS_UNDER_13' });
    }
    if (query.type === TIPS_TYPE.BROWER_DISABLE) {
      browerDiable = true;
      url = localStorage.getItem('url') || '';
      text = formatMessage({ id: 'BROWER_DISABLE' }, { name: checkBrowerAble() });
    }
  }
  function copy() {
    copyToClipboard(url);
    message.info({
      content: formatMessage({ id: 'COPY_SUCCESS' }),
      icon: null,
    });
  }
  function downloadApp() {
    const href = 'https://popo.gdl.netease.com/92.0.4515.107_chrome_installer_64.exe';
    const a = document.createElement('a');
    a.setAttribute('href', href);
    a.setAttribute('target', '_blank');
    a.click();
  }
  // const { meetingId } = useParams<ParamsStruct>();
  return (
    <div className={Style['popo-meeting-tips-page']}>
      <div className={Style.content}>
        <img className={Style.image} src={require('../../assets/meeting-ending.png')} alt="" />
        <h1 className={classnames(Style.title, { [Style.white]: browerDiable })}>{text}</h1>
        {browerDiable && (
          <div className={Style.copy}>
            <Button type="primary" onClick={downloadApp} className={Style.btn}>
              下载浏览器
            </Button>
            <br />
            <Button onClick={copy} type="primary" className={Style.btn}>
              {formatMessage({ id: 'COPY_URL' })}
            </Button>
          </div>
        )}
      </div>
      <YunxinBottom />
    </div>
  );
};

export default Tips;
